import * as React from "react";
import { useTranslation } from "react-i18next";
import { InvalidLicenseWarning } from "license/LicenseCheck";
import { PageHeader, DocumentTitle, Spinner } from "components/common";
import DocsHelper from "util/DocsHelper";
import UserSearchFilterEdit from "search-filter/components/filter-management-pages/UserSearchFilterEdit";
import SearchFilterPageSubactions from "search-filter/components/filter-management-pages/SearchFilterPageSubactions";
import useSearchFilterLicenseStatus from "search-filter/hooks/useSearchFilterLicenseStatus";
const MyFiltersEditPage = () => {
  const { isFetchingLicense, isValidLicense } = useSearchFilterLicenseStatus();
  const { t } = useTranslation("enterprise_search");
  if (isFetchingLicense) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("my_filters_edit_page.document_title") }, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: t("my_filters_edit_page.title"),
      actions: /* @__PURE__ */ React.createElement(SearchFilterPageSubactions, null),
      documentationLink: {
        title: t("my_filters_edit_page.docs_title"),
        path: DocsHelper.PAGES.SEARCH_FILTERS
      }
    },
    /* @__PURE__ */ React.createElement("span", null, t("my_filters_edit_page.description"))
  ), isValidLicense ? /* @__PURE__ */ React.createElement(UserSearchFilterEdit, null) : /* @__PURE__ */ React.createElement(
    InvalidLicenseWarning,
    {
      featureName: t("my_filters_edit_page.feature_name"),
      licenseSubject: "/license/enterprise/search-filter",
      displayWarningContainer: true
    }
  ));
};
export default MyFiltersEditPage;
